module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_shibuya-ac90b9f6bc7b719222e54cde682f3a25.jpg";